import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AutoOrderDto, AutoOrderResponse} from "../../../../core/responses/AutoOrderResponse";
import {Subject} from "rxjs";
import {AutoOrderState} from "../../../../core/helpers/enums";
import {AutoOrderService} from "../../../../core/service/auto-order.service";
import {takeUntil} from "rxjs/operators";
import {isMobile} from "../../../../core/helpers/constants";
import {Router} from "@angular/router";

@Component({
  selector: 'app-auto-order-summary',
  templateUrl: './auto-order-summary.component.html',
  styleUrls: ['./auto-order-summary.component.scss']
})
export class AutoOrderSummaryComponent implements OnInit, OnDestroy {

  @Input() userId: string;
  @Input() subdomain: string;
  @Input() benefitId: number;
  @Input() benefitName: string;
  @Input() beneficiaryId?: number;
  @Input() fixedQuantity: number | null = null;
  @Output() autoOrderSettings = new EventEmitter<{ isAutoOrderEnabled: boolean,
    hasDynamicQuantity: boolean }>();

  autoOrder: AutoOrderDto;
  autoOrderState: AutoOrderState;
  hasDynamicQuantity: boolean = false;
  canActivateAutoOrder: boolean;

  stateOptions = [
    {label: 'HISTORY.AUTO_ORDER.AUTO_ORDER_STATUS.ACTIVE', value: AutoOrderState.Active},
    {label: 'HISTORY.AUTO_ORDER.AUTO_ORDER_STATUS.INACTIVE', value: AutoOrderState.Inactive}
  ];
  private ngUnsubscribe = new Subject();

  constructor(private autoOrderService: AutoOrderService,
              private router: Router) {
  }

  ngOnInit(): void {
    this.getAutoOrder();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  protected emitAutoOrderSettings(): void {
    this.autoOrderSettings.emit({
      isAutoOrderEnabled: this.autoOrderState === AutoOrderState.Active,
      hasDynamicQuantity: this.hasDynamicQuantity
    });
  }

  private getAutoOrder() {
    this.autoOrderService.getAutoOrder(this.userId, this.benefitId, this.beneficiaryId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data: AutoOrderResponse) => {
          this.onGetAutoOrderSuccess(data);
        },
        error: (err) => {
          this.onGetAutoOrderFail(err);
        }
      });
  }

  private onGetAutoOrderSuccess(data: AutoOrderResponse) {
    this.autoOrder = data.responseObject;
    if (this.autoOrder !== null) {
      this.autoOrderState = this.autoOrder.isActive === true ? AutoOrderState.Active : AutoOrderState.Inactive;
      this.hasDynamicQuantity = this.autoOrder.hasDynamicQuantity;
    } else {
      this.autoOrderState = AutoOrderState.Inactive
    }

    this.canActivateAutoOrder = this.autoOrderState !== AutoOrderState.Active;
  }

  private onGetAutoOrderFail(err: any) {

  }

  navigateToPage(path: string) {
    if (isMobile()) {
      // Stay in app
      this.router.navigate([path]).then(_ => {});
    } else {
      // Open in new tab on desktop
      const url = this.router.serializeUrl(this.router.createUrlTree([path]));
      window.open(url, '_blank');
    }
  }

  protected readonly AutoOrderState = AutoOrderState;
}
